import { StratumService, WINDOW_DEBUG_FLAG_KEY } from '@cof/stratum';
import {
  PRODUCT_NAME,
  PRODUCT_VERSION,
  TAG_CATALOG,
} from '@cof/tag-catalog-fs-creditpull-mfe';
import { RefiNewRelicPlugin } from '../utils/new-relic-plugin';

export const stratum = new StratumService(TAG_CATALOG, {
  productName: PRODUCT_NAME,
  productVersion: PRODUCT_VERSION,
  plugins: [RefiNewRelicPlugin()],
});

if (
  window.location.host !== 'coaf-creditpull-mfe.capitalone.com' ||
  window.location.host !== 'coaf-refi-web-ui.capitalone.com' ||
  window.location.host !== 'autorefi.capitalone.com'
) {
  window[WINDOW_DEBUG_FLAG_KEY] = true;
  stratum.addEventListener((event) => {
    console.log('Stratum Event Received', event);
  });
}
